import moment from 'moment';
import type { GeofenceAPI, GeofenceGraphQLAPI } from './Definitions/ApiTypes';

import { type Geofence, GeofenceCategory } from '@cobliteam/common-types';

export const parseCategory = (category: GeofenceAPI['category']): GeofenceCategory | undefined => {
  switch (category) {
    case 'base':
      return GeofenceCategory.BASE;
    case 'client':
      return GeofenceCategory.CLIENT;
    case 'other':
      return GeofenceCategory.OTHER;
    default:
      return undefined;
  }
};

export const geofenceTransformer = (geofenceAPI: GeofenceAPI): Geofence => {
  const { geojson } = geofenceAPI;
  const parsedCategory = parseCategory(geofenceAPI.category);
  return {
    id: geofenceAPI.id,
    name: geofenceAPI.name,
    ...(parsedCategory && { category: parsedCategory }),
    createdAt: moment(geofenceAPI.created_at).valueOf(),
    geojson,
    radius: geojson.properties.radius,
    address: geojson.properties.address,
    centerLatLong: {
      latitude: geojson.properties.coordinate[1],
      longitude: geojson.properties.coordinate[0],
    },
  };
};

export const geofenceGraphQLTransformer = (geofence: GeofenceGraphQLAPI): Geofence => {
  const { id, name, category, geojson } = geofence;
  const parsedCategory = parseCategory(category);
  return {
    id,
    name,
    ...(parsedCategory && { category: parsedCategory }),
    createdAt: moment(geofence.createdAt).valueOf(),
    geojson,
    radius: geojson.properties.radius,
    address: geojson.properties.address,
    centerLatLong: {
      latitude: geojson.properties.coordinate[1],
      longitude: geojson.properties.coordinate[0],
    },
  };
};

export const geofencesTransformer = (response: GeofenceAPI[]): Geofence[] => response.map(geofenceTransformer);

export const geofencesGraphQLTransformer = (response: GeofenceGraphQLAPI[]): Geofence[] => response.map(geofenceGraphQLTransformer);
